import { useEffect } from "react";

const DEFAULT_TITLE = "Pirate Bowling Center Velburg – Bowling, Bar & Entertainment | Oberpfalz";
const DEFAULT_DESCRIPTION = "Pirate Bowling Center Velburg – Bowling, Billard, Dart, Tischkicker & Bar in der Oberpfalz. Jetzt Bahn reservieren! Bowlingcenter Velburg, Freizeit Oberpfalz.";

function setMetaContent(name, content, attr = "name") {
  if (!content) return;
  let tag = document.querySelector(`meta[${attr}="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

export function usePageMeta({ title, description, noindex = false } = {}) {
  useEffect(() => {
    const previousTitle = document.title;
    const previousDescription = document.querySelector('meta[name="description"]')?.getAttribute("content");
    const previousRobots = document.querySelector('meta[name="robots"]')?.getAttribute("content");

    if (title) document.title = title;
    if (description) setMetaContent("description", description);
    if (noindex) setMetaContent("robots", "noindex, follow");

    return () => {
      document.title = previousTitle || DEFAULT_TITLE;
      if (previousDescription) setMetaContent("description", previousDescription);
      else setMetaContent("description", DEFAULT_DESCRIPTION);
      if (previousRobots) setMetaContent("robots", previousRobots);
      else setMetaContent("robots", "index, follow");
    };
  }, [title, description, noindex]);
}
